// src/routes/AppRoutes.jsx
import React from "react";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import AppLayout from "../components/AppLayout";

import AuthLayout from "../layouts/AuthLayout";
import ChatLayout from "../layouts/ChatLayout";
import ClipsLayout from "../layouts/ClipsLayout";

import Login from "../pages/Login";
import Signup from "../pages/Signup";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import ConfirmEmail from "../pages/ConfirmEmail";

import MainFeed from "../pages/MainFeed";
import EditProfilePage from "../pages/EditProfilePage";
import ProfileWrapper from "../pages/ProfileWrapper";
import FollowersPage from "../pages/FollowersPage";
import Conversations from "../pages/Conversations";
import NewConversation from "../pages/NewConversation";
import Chat from "../pages/Chat";
import PrivacySettings from "../pages/PrivacySettings";
import SearchPage from "../pages/SearchPage";
import CreatePost from "../pages/CreatePost";
import Clips from "../pages/Clips";
import ChangePassword from "../pages/ChangePassword";
import SupportedPosts from "../pages/SupportedPosts";
import AdminReports from "../pages/AdminReports";
import CreateFootprint from "../pages/CreateFootprint";
import Location from "../pages/Location";
import PostPage from "../pages/PostPage";
import ClipDetail from "../pages/ClipDetail";

function ProtectedRoute({ token, children }) {
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default function AppRoutes({
  token,
  setToken,
}) {
  return (
    <Routes>

      {/* AUTH */}
      <Route element={<AuthLayout />}>

        <Route
          path="/login"
          element={
            token
              ? <Navigate to="/" replace />
              : <Login onLogin={setToken} />
          }
        />

        <Route
          path="/signup"
          element={
            token
              ? <Navigate to="/" replace />
              : <Signup />
          }
        />

        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />

        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />

        <Route
          path="/confirm-email"
          element={<ConfirmEmail />}
        />

      </Route>

      {/* MAIN APP */}
      <Route
        element={
          <ProtectedRoute token={token}>
            <AppLayout />
          </ProtectedRoute>
        }
      >

        <Route path="/" element={<MainFeed />} />

        <Route
          path="/edit-profile"
          element={<EditProfilePage />}
        />

        <Route
          path="/u/:handle"
          element={<ProfileWrapper />}
        />

        <Route
          path="/u/:handle/follows"
          element={<FollowersPage />}
        />

        <Route
          path="/conversations"
          element={<Conversations />}
        />

        <Route
          path="/conversations/new"
          element={<NewConversation />}
        />

        <Route
          path="/privacy"
          element={<PrivacySettings />}
        />

        <Route
          path="/search"
          element={<SearchPage />}
        />

        <Route
          path="/create"
          element={<CreatePost />}
        />

        <Route
          path="/change-password"
          element={<ChangePassword />}
        />

        <Route
          path="/supported"
          element={<SupportedPosts />}
        />
        
        <Route path="/post/:id" element={<PostPage />} />
        
        <Route
  path="/admin/reports"
  element={<AdminReports />}
/>

        <Route
  path="/footprints/new"
  element={<CreateFootprint />}
/>

        <Route
  path="/location/:id"
  element={<Location />}
/>

      </Route>

      {/* CHAT */}
      <Route
        element={
          <ProtectedRoute token={token}>
            <ChatLayout />
          </ProtectedRoute>
        }
      >

        <Route
          path="/chat/:conversationId"
          element={<Chat />}
        />

      </Route>

      {/* CLIPS */}
<Route
  element={
    <ProtectedRoute token={token}>
      <ClipsLayout />
    </ProtectedRoute>
  }
>
  <Route
    path="/clips"
    element={<Clips />}
  />

  <Route
    path="/clips/:id"
    element={<PostPage />}
  />
</Route>

    </Routes>
  );
}